/**
 * Leaves the console for another site, as a full page load.
 *
 * One function rather than `window.location.href =` at each call site, so a
 * spec can see where a button sends somebody: jsdom does not navigate.
 *
 * `replace` takes the page being left out of the history, for a page that
 * must not be come back to with Back.
 */
export const leaveFor = (
  url: string,
  { replace = false }: { replace?: boolean } = {},
): void => {
  if (replace) {
    window.location.replace(url)
  } else {
    window.location.assign(url)
  }
}
